import { z } from 'zod/v4';
import { PatchedOrderSchema, TRACING_ORDER_STATUSES } from './patch-order.js';

export const BulkPatchOrdersBodySchema = z.object({
  /** At least one, none empty, no repeats. Ids that are not the caller's orders are skipped. */
  ids: z
    .array(z.string().min(1))
    .min(1)
    .refine(ids => new Set(ids).size === ids.length, {
      message: 'ids must be unique',
    }),
  order: z.object({
    /** Required: legacy accepted `null` (or none) and wrote NULL. */
    status: z.enum(TRACING_ORDER_STATUSES),
  }),
});

export type BulkPatchOrdersBody = z.infer<typeof BulkPatchOrdersBodySchema>;

/** The orders the patch changed, in the order asked. */
export const BulkPatchedOrderListSchema = z.array(PatchedOrderSchema);

/** Wire shape: the standard `reply.apiSuccess` envelope around the list. */
export const BulkPatchOrdersResponseSchema = z.object({
  metadata: z.object({ success: z.literal(true) }),
  data: BulkPatchedOrderListSchema,
});

export type BulkPatchOrdersResponse = z.infer<
  typeof BulkPatchOrdersResponseSchema
>;
